import axios from 'axios';
import {API} from "@/services/url";


export default {
	getGeneralSettings : function (params,success, error) {
		axios.get(API.generalSettings.all,{params:params})
			.then(r => success(r.data.generalSettingsGroupKeys))
			.catch(e => error(e.response.data.message));
	},
	updateGeneralSettingsOfAnOffice: function (data,success, error) {
		axios.post(API.generalSettings.all,data)
			.then(r => success())
			.catch(e => error());
	},
	generateParkingDummyData: function (data,success, error) {
		axios.post(API.generalSettings.parking,data)
			.then(r => success())
			.catch(e => error());
	},
	generateMembershipDummyData: function (data,success, error) {
		axios.post(API.generalSettings.membership,data)
			.then(r => success())
			.catch(e => error());
	},
	generateSiteDummyData: function (data,success, error) {
		axios.post(API.generalSettings.site,data)
			.then(r => success())
			.catch(e => error());
	},
}
